import { render, staticRenderFns } from "./ManualAggregationActionButton.vue?vue&type=template&id=66bd906e&scoped=true"
import script from "./ManualAggregationActionButton.vue?vue&type=script&lang=js"
export * from "./ManualAggregationActionButton.vue?vue&type=script&lang=js"
import style0 from "./ManualAggregationActionButton.vue?vue&type=style&index=0&id=66bd906e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd906e",
  null
  
)

export default component.exports